import React from 'react';
import CardMedia from '@mui/material/CardMedia';

interface CustomImageType {
    src: string;
    alt: string;
    className?: string;
    height?: string;
}

const CustomImage = (props: CustomImageType) => {
    return (
        <CardMedia
            component="img"
            image={props.src}
            alt={props.alt}
            className={props.className}
            height={props.height}
        />
    );
}

export default CustomImage;